<template>
    <figure
        class='one-card'
        :style="{ '--width': width, }"
        :class="{ }"
    >
        <div v-if="real" class="card-inner"
            :class="{ 'face-up': isFaceUp }"
        >
            <div v-if="card?.rank" class='front'>
                <span class="number" >
                    {{ card?.rank }} 
                </span>
                <IconSvgUse
                    v-if="card?.suit"
                    fileName="hilo"
                    size="57%"
                    _width="57%"
                    _height="57%"
                    :use="`hilo-${card?.suit}`"
                > </IconSvgUse>
            </div>
            
            <div class="back">
                <img src="../img/card-back.webp" alt="反面" />
            </div>
        </div>
    </figure>
</template>

<script setup lang="ts">
import { aAllCards, a4suits } from '~/pages/casino/jisuzhajinhuaGame/ts/cardsConstant';

const props = defineProps({
    width: {
        type: String,
        default: '30px',
    },
    cardName: {
        // 入参示例如下： （与后端的牌面表示法一致） 
        // 'spades2', 'hearts2', 'diamonds2', 'clubs2', 'spades3', 
        type: String, 
        // default: aAllCards[~~(50 * Math.random())], // TODO 用于测试 
        default: '', 
    },
    real: {
        type: Boolean
    }
});

// 允许通过空 suit/rank 表示背面（开牌前），保持 cardName 为空也视为背面
const isFaceUp = computed(() => !!props.cardName);

const card = computed(() => {
    const parsed = parseCard(props.cardName);
    return parsed || { suit: '', rank: '' };
});

const color = computed(() => {
    const beRed = props.cardName.match(/hearts|diamonds/i); 
    const sColor = beRed ? '#f04051' : '#26292f';
    return sColor;
});

function parseCard(str) {
    for (const suit of a4suits) {
        if (str.startsWith(suit)) {
            return {
                suit: suit.slice(0, -1), // 去掉最后的 "s" 变单数
                rank: str.slice(suit.length),
            };
        }
    }
    return null;
}
</script>

<style scoped lang="scss">

.one-card{
    width: var(--width);
    height: calc(var(--width) * 1.334);
    font-size: calc(var(--width) * 0.45); // 控制数字的字号 
    perspective: 1000px;
    display: inline-flex; 
    flex-direction: column;
    align-items: center;
}


.card-inner {
    width: 100%;
    height: 100%;
    // width: var(--width);
    // height: calc(var(--width) * 1.34);
    position: relative;
    transform-style: preserve-3d;
    transition: transform 0.3s linear; 
    transform: rotateY(180deg);
    // filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.5));
    // box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5); 
    &.face-up {
        transform: rotateY(0deg);
    }
}


.front,
.back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 4px;
    overflow: hidden;
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.5));
    img {
        width: 101%;
        height: 101%;
        object-fit: cover;
        object-position: center; 
    }
}


.front{
    background-color: white;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    .number{
        color: v-bind('color');
        font-weight: bold;
        line-height: 1;
        align-self: flex-start;
        margin: 2px 0 0px calc(var(--width) * 0.15);  
    }
    & > svg{
        align-self: flex-end;
        margin: 0 auto 0; 
    }
}

.back {
    transform: rotateY(180deg);
    display: flex;
    justify-content: center; 
    align-items: center; 
    background-color: white; 
}


</style>

